import React from 'react';
import './MessageBox.scss';


function SearchBoxes({message, parentCallBack}) {

function click() {
    parentCallBack();
}

    return(
        <div className={`message-box ${message !== ''? '' : 'hide'}`}>
            <i className='warningIcon message-box__icon' />
            <span className="message-box__label">{message}</span>
            <div className="message-box__closing-box" onClick={click}>
                <span className="message-box__closing-box__icon-x"></span>
            </div>
        </div>
    );
};

export default SearchBoxes;